import { useNavigate } from 'react-router-dom';
import { Icon, type IconName } from './Icon';

export const TopBar = ({ left, right, title, transparent = false }: { left?: React.ReactNode; right?: React.ReactNode; title?: React.ReactNode; transparent?: boolean }) => (
  <div className={`flex items-center justify-between px-5 h-12 ${transparent ? '' : 'bg-[var(--bg)]/70 backdrop-blur'}`}>
    <div className="w-20 flex items-center gap-2">{left}</div>
    <div className="text-sm font-medium truncate">{title}</div>
    <div className="w-20 flex items-center gap-2 justify-end">{right}</div>
  </div>
);

export const IconBtn = ({ name, onClick, className = '', strokeWidth = 1.8, size = 'w-5 h-5' }: { name: IconName; onClick?: () => void; className?: string; strokeWidth?: number; size?: string }) => (
  <button onClick={onClick} className={`w-9 h-9 rounded-full bg-black/5 hover:bg-black/10 dark:bg-white/10 dark:hover:bg-white/15 flex items-center justify-center transition ${className}`}>
    <Icon name={name} className={size} strokeWidth={strokeWidth} />
  </button>
);

export const Progress = ({ value, className = 'h-1' }: { value: number; className?: string }) => (
  <div className={`w-full rounded-full progress-track ${className}`}>
    <div className="h-full rounded-full bg-ink-900 dark:bg-cream-100 transition-all" style={{ width: `${Math.round(value * 100)}%` }} />
  </div>
);

export const ProgressColor = ({ value, color, className = 'h-1' }: { value: number; color: string; className?: string }) => (
  <div className={`w-full rounded-full progress-track ${className}`}>
    <div className="h-full rounded-full transition-all" style={{ width: `${value * 100}%`, background: color }} />
  </div>
);

export const TabBar = ({ active = 'library' }: { active?: string }) => {
  const nav = useNavigate();
  const tabs: { id: string; label: string; icon: IconName; to: string }[] = [
    { id: 'library', label: 'Library', icon: 'library', to: '/' },
    { id: 'search', label: 'Search', icon: 'search', to: '/search' },
    { id: 'habits', label: 'Habits', icon: 'flame', to: '/habits' },
    { id: 'settings', label: 'Settings', icon: 'settings', to: '/settings' },
  ];
  return (
    <div className="absolute left-0 right-0 bottom-0 px-4 pb-6 pt-2 safe-bottom">
      <div className="rounded-full bg-paper/95 dark:bg-night-800/95 backdrop-blur shadow-card flex items-center px-1.5 py-1.5">
        {tabs.map((t) => (
          <button key={t.id} onClick={() => nav(t.to)} className={`flex-1 flex flex-col items-center gap-0.5 py-1.5 rounded-full transition ${active === t.id ? 'bg-ink-900 text-cream-50 dark:bg-cream-100 dark:text-ink-900' : 'text-ink-500'}`}>
            <Icon name={t.icon} className="w-[18px] h-[18px]" />
            <span className="text-[10px] font-medium">{t.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export const PhoneFrame = ({ children }: { children: React.ReactNode }) => (
  <div className="relative h-full w-full overflow-hidden">{children}</div>
);
